import React, {Fragment} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/sysDepartment";
import ModifyModal from "./modifyModal";
import useFormModal from "../../../../utils/useFormModal";
import withAuth from "../../../../utils/withAuth";
import {Button, Popconfirm, Space} from "antd";
import Divider from "../../../../components/Divider";
import {useRequest} from "ahooks";

const AddButton = withAuth('add', Button)
const EditFragment = withAuth('edit', Fragment)
const DeletePopconfirm = withAuth('delete', Popconfirm)

function SysDepartment() {

    const {tableProps, refresh} = useAntTable(api.getDepartments, {})

    const {modalProps, setVisible} = useFormModal({
        onRequest: api.modifyDepartment,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const {run: onDelete} = useRequest(api.deleteDepartment, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '编号',
            dataIndex: 'code',
        },
        {
            title: '名称',
            dataIndex: 'name',
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <Divider>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>编辑</a>
                    </EditFragment>
                    <DeletePopconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </DeletePopconfirm>
                </Divider>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>新增</AddButton>
                </Space>
            )}/>
            <ModifyModal  {...modalProps}/>
        </PageHeaderLayout>
    )
}

export default SysDepartment
